import type { RouteRecordRaw } from 'vue-router'

export const phoneRoutes: RouteRecordRaw[] = [
  {
    path: '/phone-number-purchasing',
    name: 'phone-number-purchasing',
    component: () => import('./purchase/pages/PhoneNumberPurchasingPage.vue')
  },
  {
    path: '/phone-numbers',
    name: 'phone-numbers-manage',
    component: () => import('./manage/pages/PhoneNumbersManagePage.vue')
  },
  {
    path: '/phone-numbers/:id/edit',
    name: 'phone-number-edit',
    component: () => import('./manage/pages/PhoneNumberEditPage.vue')
  }
]
